import { Table, Tag } from "antd";

const columns = [
    {
        title: "Formulário",
        dataIndex: "_index",
        key: "form",
        render: (v) => <Tag>{v.replace("obj_", "")}</Tag>
    },
    {
        title: "Campo Referênciado",
        dataIndex: "fieldCalledName",
        key: "field",
        render: (v) => <Tag color="orange"> {v} </Tag>
    }
];

export default function ReferenceFieldsRefTable(props) {
    const data = props.conflicts;

    return (
        <Table
            size="small"
            bordered
            columns={columns}
            dataSource={data}
            pagination={false}
            locale={{ emptyText: "Nenhum filtro encontrado." }}
            style={{ marginTop: 12 }}
            scroll={{y: 300}}
        />
    )
}